import {Storage} from 'aws-amplify';
import {config} from 'stage.config';

export enum PolicyType {
  TERMS_OF_SERVICE = 'terms_of_service'
}

export const getPolicies = () => {
  return {
    [PolicyType.TERMS_OF_SERVICE]: {
      title: 'Legal Notice',
      doc: config.termsOfServiceDoc,
      cognitoDocField: 'custom:tos_doc',
      cognitoDateField: 'custom:tos_accepted_at'
    }
  };
};

export const getPolicyUrl = async (name: string) => {
  return Storage.get(name, {level: 'protected', bucket: config.adminBucket, identityId: 'shared'});
};
